import {
  ALOG_ALOG_MODAL_CHANGE,
} from './constants';

export function alogModalChange(visible,type) {
  return {
    type: ALOG_ALOG_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case ALOG_ALOG_MODAL_CHANGE:
      return {
        ...state,
        alogModalType:action.data.type,
        alogModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/alog/redux/alogModalChange.js